app.component("opNotePayer", {
	templateUrl: "app/src/js/components/opNotePayer/opNotePayer.html",
	bindings: {
		note: "<",
		patient: "<",
		operativeEye: "<",
		practiceType: "<",
		submitted: "<?",
	},
	controller: [
		"Insurance",
		function (Insurance) {
			var $ctrl = this;

			function sections() {
				var note = $ctrl.note || {};
				return [note.op_note_od, note.op_note_os].filter(function (s) { return !!s; });
			}

			function applyToAll(value) {
				sections().forEach(function (section) { section.payer = value; });
			}

			// Nothing to ask when the answer is already known: a public hospital always bills
			// Public, a patient recorded as self-paying pays for this too, and a patient holding a
			// single insurer has only one thing they could be.
			// Returns null when the question genuinely has to be put to the user.
			function implicitPayer() {
				if ($ctrl.practiceType === "DHB_PUBLIC") {
					return Insurance.PUBLIC;
				}
				if (Insurance.isSelfPaid($ctrl.patient)) {
					return Insurance.NONE;
				}
				// Self-pay recorded alongside cover means either could pay, so the user has to be
				// asked even though only one insurer is held. Guessing here would bill a fund the
				// patient may have chosen not to use.
				if (Insurance.has($ctrl.patient, Insurance.NONE)) {
					return null;
				}
				var chosen = Insurance.selected($ctrl.patient);
				return chosen.length === 1 ? chosen[0] : null;
			}

			// The op note object and the patient can both arrive after this component is first
			// linked, so everything derived from them is recomputed rather than read once.
			function refresh() {
				$ctrl.options = Insurance.payerOptions($ctrl.patient);
				$ctrl.hasInsurance = Insurance.hasAny($ctrl.patient);
				// Only ever shown when the box is visible, i.e. the patient has no recorded answer
				// or has more than one possible payer - never for a patient whose payer is implicit
				// above.
				$ctrl.isUnset = !Insurance.isAnswered($ctrl.patient);

				var implicit = implicitPayer();
				$ctrl.hidden = implicit !== null;

				if ($ctrl.hidden) {
					$ctrl.payer = implicit;
				} else if ($ctrl.bothEyes === false && $ctrl.operativeEye !== "BOTH") {
					// Down to one eye after answering per eye: carry that eye's answer into the single
					// select, which is the only one shown now, rather than showing it blank.
					var note = $ctrl.note || {};
					var section = $ctrl.operativeEye === "OS" ? note.op_note_os : note.op_note_od;
					$ctrl.bothEyes = true;
					$ctrl.payer = (section && section.payer) || null;
				}

				// Re-applied on every refresh because the sections may only exist now.
				if ($ctrl.hidden || $ctrl.bothEyes) {
					applyToAll($ctrl.payer);
				}
			}

			$ctrl.$onInit = function () {
				$ctrl.bothEyes = true;
				$ctrl.payer = null;
				refresh();
			};

			$ctrl.$onChanges = refresh;

			// Only offered when the note covers both eyes; otherwise there is one eye to bill.
			$ctrl.showBothEyesToggle = function () {
				return $ctrl.operativeEye === "BOTH";
			};

			$ctrl.showEye = function (eye) {
				return $ctrl.operativeEye === "BOTH" || $ctrl.operativeEye === eye;
			};

			$ctrl.onSingleChange = function () {
				applyToAll($ctrl.payer);
			};

			// True while an eye being operated on still has no payer. Mirrors the rule enforced in
			// operationNoteController.checkValid, so what the box says and what blocks submit
			// cannot disagree.
			$ctrl.missing = function () {
				return sections().some(function (section) {
					return section.operative_eye === "YES" && !section.payer;
				});
			};

			$ctrl.onBothEyesChange = function () {
				if (!$ctrl.bothEyes) {
					return;
				}
				// Collapsing two answers back into one: the right eye's choice is the one kept,
				// falling back to the left when only that eye was answered.
				var note = $ctrl.note || {};
				var od = note.op_note_od && note.op_note_od.payer;
				var os = note.op_note_os && note.op_note_os.payer;
				$ctrl.payer = od || os || null;
				applyToAll($ctrl.payer);
			};
		},
	],
});
